import { useEffect, useState, useSyncExternalStore } from 'react';
import type { EstadoMesa, FonteDaMesa } from '../mesa/conexao.ts';

export function useMesa<E extends EstadoMesa = EstadoMesa>(c: Pick<FonteDaMesa, 'assinar'> & { obter(): E }): E {
  return useSyncExternalStore(c.assinar, c.obter);
}

// Hora do servidor agora, para comparar com os prazos (que chegam em horário do servidor).
export function agoraNoServidor(e: EstadoMesa): number {
  return Date.now() + e.desvio;
}

// Redesenha 4 vezes por segundo, para os relógios dos prazos andarem na tela.
export function useAgora(intervalo = 250): number {
  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => { const t = setInterval(() => setAgora(Date.now()), intervalo); return () => clearInterval(t); }, [intervalo]);
  return agora;
}
